import React from 'react';

import {formatTypedValue} from 'notebook/tables/typed-values/DataTypes';
import {BaseTypedValueType, TypedValue} from 'notebook/tables/typed-values/TypedValueConstants';
import BenchChip from 'ui-library/chips/BenchChip';
import {ChipSize} from 'ui-library/chips/Chip';

interface BulkAssemblyConstructNameProps {
  typedValue: TypedValue;
}

/**
 * Custom cell implementation for the construct name column.
 *
 * For in-progress assemblies, we simply show the string name.
 * For finalized assemblies, we show a chip to the created construct.
 *
 * This needs to be a custom column because we don't want to attempt string resolution or other
 * features in the plain string case.
 */
export default function BulkAssemblyConstructName({typedValue}: BulkAssemblyConstructNameProps): JSX.Element {
  if (typedValue.type === BaseTypedValueType.BIOENTITY) {
    return <BenchChip id={typedValue.bioentitySummary.id} size={ChipSize.TABLE_CELL} />;
  }
  return <span>{formatTypedValue(typedValue)}</span>;
}
